import ButtonLogOut from "./buttonLogOut";
import logo from "../../assets/images/logoFederfarma.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ButtonHeader from "../common/buttonHeader";
import { t } from "i18next";
import DropDownButtonIcon from "../common/dropDownButtonIcon";
import { downloadDocument } from "../../utils/helpers";
import { logOut } from "../../services/Auth";

const Header = (props: any) => {
  let titleLogOut = props.titleLogOut ?? "";

  const { user, saml, urlDownloadReport, urlDownloadConditionsUse } = useSelector(
    (store: any) => store.login
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const path = window.location.pathname;

  const goToListpharmacyList = () => {
    navigate("/pharmacyList");
  };

  const goToStatistics = () => {
    navigate("/statistics");
  };

  return (
    <div className="Header">
      <div className="row m-0">
        <div className="col-12 col-xl-2 col-lg-3  text-lg-left text-center p-30">
          <img alt="Logo" src={logo} className="logoHeader" />
        </div>
        <div className="col-12 col-xl-5 text-lg-left text-center d-flex align-items-center">
          <div className="d-inline mr-3">
            {user &&
              user.modules &&
              user.modules.includes("FEDERFARMA_ASSOCIAZIONE_PROVINCIALE") &&
              !user.modules.includes("FEDERFARMA_SURVEYS") ? (
              <ButtonHeader
                handleChange={() => {
                  goToListpharmacyList();
                }}
                active={path === "/pharmacyList"}
                icon="calendar_today"
                textButton={t("labelAllPharmacies")}
              />
            ) : (
              <></>
            )}
          </div>
          <div className="d-inline mr-3">
            {user &&
              user.modules &&
              user.modules.includes("FEDERFARMA_PHARMACIES_STATISTICS") ? (
              <ButtonHeader
                handleChange={() => {
                  goToStatistics();
                }}
                active={path === "/statistics"}
                icon="insert_chart"
                textButton={t("labelStatistics")}
              />
            ) : (
              <></>
            )}
          </div>
          <div className="d-inline mr-3">
            {user &&
              user.modules &&
              user.modules.includes("FEDERFARMA_ENROLLMENT") &&
              path !== "/dashboard" ? (
              <ButtonHeader
                handleChange={() => {
                  navigate("/enrollment");
                }}
                active={/^\/enrollment(\/.*)?$/.test(path)}
                icon="identity_platform"
                textButton={t("headerSection.enrollment")}
              />
            ) : (
              <></>
            )}
          </div>
          <div className="d-inline mr-3">
            {user &&
              user.modules &&
              user.modules.includes("FEDERFARMA_SURVEYS") &&
              path !== "/dashboard" ? (
              <ButtonHeader
                handleChange={() => {
                  navigate("/surveys");
                }}
                active={/^\/surveys(\/.*)?$/.test(path)}
                icon="bar_chart"
                textButton={t("headerSection.report")}
              />
            ) : (
              <></>
            )}
          </div>
          {urlDownloadConditionsUse && (
            <div className="d-inline mr-3">
              <ButtonHeader
                handleChange={() => {
                  window.open(urlDownloadConditionsUse, "_blank");
                }}
                icon="download"
                textButton={t("headerSection.conditions-use")}
              />
            </div>
          )}
          <div className="d-inline mr-3">
            {path !== "/dashboard" &&
              user &&
              user.modules &&
              user.modules.includes("FEDERFARMA_REPORT_DOWNLOAD") &&
              urlDownloadReport ? (
              <DropDownButtonIcon
                active={/^\/download(\/.*)?$/.test(path)}
                handleClickAction={() => downloadDocument(urlDownloadReport)}
                textButton={t("download")}
                icon="download"
                dropdownItems={[
                  {
                    title: t("report-date-range", { date: "31-12-2024" }),
                  },
                ]}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="col text-lg-right text-center p-30">
          <ButtonLogOut title={titleLogOut} handleClick={logOut} />
        </div>
      </div>
    </div>
  );
};

export default Header;
